import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../global/hooks';
import {
	selectActiveChordId,
	selectActiveSectionId,
	setActiveChordId,
	setActiveSectionId,
	setView
} from '../../store/appSlice';
import DeleteButton from '../Buttons/DeleteButton';
import { removeChord } from '../../store/sectionsSlice';

export default function DeleteChord() {
	const chordId = useAppSelector(selectActiveChordId);
	const sectionId = useAppSelector(selectActiveSectionId);
	const dispatch = useDispatch();
	const handleDeleteChord = () => {
		if (chordId != null && sectionId != null) {
			dispatch(removeChord({ chordId, sectionId }));
			dispatch(setActiveChordId(null));
			dispatch(setActiveSectionId(null));
			dispatch(setView('main'));
		}
	};
	return chordId !== null ? (
		<DeleteButton onClick={handleDeleteChord} title="Delete chord">
			Delete chord
		</DeleteButton>
	) : null;
}
